import React from "react";
import AboutTextContainer from "../components/AboutTextContainer";
import ContactContainer from "../components/ContactContainer";
import SectionWrapper from "../components/SectionWrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ScrollDownAnimation = () => {
    return (
        <div className="absolute m-auto left-0 right-0 bottom-[3%]">
            <div className="flex flex-col justify-center animate__animated animate__bounce animate__infinite">
                <div className="text-center">Scroll Down</div>
                <FontAwesomeIcon icon={['fas', 'chevron-down']}/>
            </div>
        </div>
    )
}

const GradientLayer = () => {
    return (
        <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-b from-[#050315] to-transparent rotate-180 z-0"></div>
    );
}

const About = () => {
    return (
        <SectionWrapper id="about">
            <AboutTextContainer/>
            <ContactContainer/>
            <ScrollDownAnimation/>
            <GradientLayer/>
        </SectionWrapper>
    );
}

export default About;